import React from 'react';
import { Box, Tooltip } from '@mui/material';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import HeaderActions from './HeaderActions';
import DownloadImportModals from './DownloadImportModals';
import { useClientHeader } from './ClientHeaderContext';
import AccountantCards from './AccountantCards';
import toolbarStyles from './HeaderToolbar.module.scss';
import '../../ClientDetails.css';

const ClientDetailsHeader = React.memo(function ClientDetailsHeader() {
  const {
    t,
    direction,
    onlyProcessedDocuments,
    setOnlyProcessedDocuments,
    isManageOnly,
  } = useClientHeader();

  // ――― choose the header-right style once ―――
  // Gaps are controlled by CSS (including the 768px media query).
  const headerRightStyle = { display: 'flex', alignItems: 'center' };

  // ManageOnly clients: hide everything that's reporting/finance related (import/export,
  // date pickers, close-month, TotalUploads card, OnlyProcessed checkbox). Only the
  // Assignments + Balance accountant cards remain. UnprocessedItems lives in MainLayout.
  const showOnlyProcessedToggle = !isManageOnly && typeof setOnlyProcessedDocuments === 'function';

  return (
    <div className="header">
      <div style={{ flex: 1 }}>
        <div className={`header-right ${toolbarStyles.toolbarControls}`} style={headerRightStyle}>
        {showOnlyProcessedToggle && (
          <Box
            className={toolbarStyles.toggleWrap}
            sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '4px' }}
          >
              <Tooltip title={t ? t('OnlyProcessedDocumentsTooltip') : ''}>
                <button
                  type="button"
                  className={`${toolbarStyles.btn} ${toolbarStyles.btnCompact} ${
                    onlyProcessedDocuments ? toolbarStyles.btnBlue : toolbarStyles.btnOutlineBlue
                  }`}
                  onClick={() => setOnlyProcessedDocuments(!onlyProcessedDocuments)}
                  aria-pressed={!!onlyProcessedDocuments}
                  dir={direction}
                >
                  <DoneAllIcon />
                  <span>{t ? t('OnlyProcessedDocuments') : 'Processed documents only'}</span>
                </button>
              </Tooltip>
          </Box>
        )}
          <AccountantCards />
          {!isManageOnly && <HeaderActions />}
          {!isManageOnly && <DownloadImportModals />}

        </div>
      </div>
    </div>
  );
});

export default ClientDetailsHeader;
